import React, { useState, useEffect } from "react";

import LibrarySplash from "./library-page/librarysplash";
import BookPage from "./library-page/book-page";
import { useNavigate } from "react-router";
function Library(props) {
    //routing

    const [splashPage, setSplashPage] = useState(true);
    const [favSites, setFavSites] = useState(false);
    const [pageName, setPageName] = useState("Featured");

    const [mediaIsSelected, setMediaSelected] = useState(false);
    const [selectedMedia, setSelectedMedia] = useState({});

    
  const scrollToSubheading = (subheading) =>{
    document.querySelector(`#${subheading}`).scrollIntoView();
  }

  const handleInfoPages = (pageName) =>{
    if (pageName == "home"){
      setPageName("Featured");
    }
    if (pageName == "literature"){
      setPageName("Literature");
    }
    if (pageName == "comics"){
      setPageName("Comics");
    }
    if (pageName == "video"){
      setPageName("Video");
    }
    if (pageName == "games"){
      setPageName("Games");
    }
  }
  let navigate = useNavigate();

    return (
      <div className='site-container'>
          <div className={'page-controller-blue'}>
    <div id = "library-wrapper-1">
    
      <button className='x-close-bookpage' id="x-close-lib-home" onClick={()=>navigate("/")}>{'<'}--- back to home</button>
      <div id = "library-wrapper" className= {(!mediaIsSelected)?'about-wrapper':'page-hidden'}> 
      <div className = "title">
              {/* <h1>🍓 Free Media Library 🍓</h1> */}
          </div> 
          <div className = "title-right">
              <h1>✦•·········· Media Library ··········•✦</h1>
          </div> 
          <div id="info-links-lib" className = "links">
              <p>links</p>
              <div id="linkswrapper-lib" className = "linkswrapper">
                  <div onClick={()=> handleInfoPages("home")}>Library - Home</div>
                  <div onClick={()=> handleInfoPages("literature")}>✮ Literature</div>
                  <div  onClick={()=> handleInfoPages("comics")}>✮ Comics</div>
                  {/* <div onClick={()=> handleInfoPages("video")}>✮ Video</div> */}
                  <div onClick={()=> handleInfoPages("games")}>✮ Games</div>
                  {/* <div onClick={()=> handleInfoPages("other")}>✮ Other</div> */}
              </div>
          </div>
          <LibrarySplash splash={splashPage} pageName={pageName} setPageName={setPageName} mediaIsSelected={mediaIsSelected} selectedMedia={selectedMedia} setSelectedMedia={setSelectedMedia} setMediaSelected={setMediaSelected}/>
            
          </div>
        </div>
        </div>
        </div>
    );
  }

  export default Library;